const fotogalleryItems = [
      {
            type: 'embed',
            provider: 'jwp',
            where: 'IlMessaggero evento Futuro Capitale',
            thumb: 'assets/images/fotogallery/thumbs/picture-video-speciale.jpg',
            embedUrl: 'https://cdn.jwplayer.com/players/IEd5HHXO.html',
            title: 'Futuro Capitale, l\'intervento di Francesco Gaetano Caltagirone'
        },
    {
        type: "embed",
        provider: "ilsole24ore",
        where: "Festival Economia Trento 2025",
        thumb: "assets/images/fotogallery/thumbs/picture-video-festivaleconomia2025.jpg",
        embedUrl: "https://stream24.ilsole24ore.com/embed/AHYSjpt",
        title: "Intervenuto sulle sfide che l’Europa si trova di fronte nel contesto internazionale"
    },
    {
        type: "url",
        provider: "vimeo",
        where: "Festival Economia Trento 2024",
        thumb: "assets/images/fotogallery/thumbs/picture-video-festivaleconomia.jpg",
      /*   embedUrl: "https://player.vimeo.com/video/1033788164", */
        url: "https://player.vimeo.com/video/1033788164",
        title: "Così cadde l’impero romano"
    },
    {
        type: "embed",
        provider: "jwp",
        where: "Campidoglio",
        thumb: "assets/images/fotogallery/thumbs/picture-video-wTkrRwY6.jpg",
        embedUrl: "https://cdn.jwplayer.com/players/wTkrRwY6.html",
        title: "Sfida Capitale, l'intervento di Francesco Gaetano Caltagirone"
    },
    {
        type: "embed",
        provider: "jwp",
        where: "IlMessaggero 145",
        thumb: "assets/images/fotogallery/thumbs/picture-video-9dBwsuat.jpg",
        embedUrl: "https://cdn.jwplayer.com/players/9dBwsuat.html",
        title: "IlMessaggero 145, «Un giornale fondato sul garantismo e sulla forza della ragione»"
    },
    {
        type: "embed",
        provider: "jwp",
        where: "Forum Messaggero in Campidoglio",
        thumb: "assets/images/fotogallery/thumbs/picture-video-noslMsgA.jpg",
        embedUrl: "https://cdn.jwplayer.com/players/noslMsgA.html",
        title: "Caltagirone, l’intervento al Forum Messaggero in Campidoglio"
    },
    {
        type: "url",
        provider: "youtube",
        where: "Otto e mezzo 27/06/13",
        thumb: "assets/images/fotogallery/thumbs/picture-10.jpg",
        //embedUrl: "https://www.youtube.com/embed/ljacuuJX29w?si=Wm8jbytkJ4coumtu",
        url: "https://www.youtube.com/watch?v=ljacuuJX29w",
        title: "Ospite Francesco Gaetano Caltagirone"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-1.jpg",
        full: "assets/images/fotogallery/picture-1.jpg",
        alt: "Fotografia 1"
    },
   /*  {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-2.jpg",
        full: "assets/images/fotogallery/picture-2.jpg",
        alt: "Fotografia 2"
    }, */
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-3.jpg",
        full: "assets/images/fotogallery/picture-3.jpg",
        alt: "Fotografia 3"
    },
   /*  {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-4.jpg",
        full: "assets/images/fotogallery/picture-4.jpg",
        alt: "Fotografia 4"
    }, */
   /*  {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-5.jpg",
        full: "assets/images/fotogallery/picture-5.jpg",
        alt: "Fotografia 5"
    }, */
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-6.jpg",
        full: "assets/images/fotogallery/picture-6.jpg",
        alt: "Fotografia 6"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-7.jpg",
        full: "assets/images/fotogallery/picture-7.jpg",
        alt: "Fotografia 7"
    },
   /*  {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-8.jpg",
        full: "assets/images/fotogallery/picture-8.jpg",
        alt: "Fotografia 8"
    }, */
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-9.jpg",
        full: "assets/images/fotogallery/picture-9.jpg",
        alt: "Fotografia 9"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-11.jpg",
        full: "assets/images/fotogallery/picture-11.jpg",
        alt: "Fotografia 11"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-12.jpg",
        full: "assets/images/fotogallery/picture-12.jpg",
        alt: "Fotografia 12"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-13.jpg",
        full: "assets/images/fotogallery/picture-13.jpg",
        alt: "Fotografia 13"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-14.jpg",
        full: "assets/images/fotogallery/picture-14.jpg",
        alt: "Fotografia 14"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-15.jpg",
        full: "assets/images/fotogallery/picture-15.jpg",
        alt: "Fotografia 15"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-16.jpg",
        full: "assets/images/fotogallery/picture-16.jpg",
        alt: "Fotografia 16"
    },
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-17.jpg",
        full: "assets/images/fotogallery/picture-17.jpg",
        alt: "Fotografia 17"
    },
/*     {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-18.jpg",
        full: "assets/images/fotogallery/picture-18.jpg",
        alt: "Fotografia 18"
    }, */
    {
        type: "image",
        thumb: "assets/images/fotogallery/thumbs/picture-19.jpg",
        full: "assets/images/fotogallery/picture-19.jpg",
        alt: "Fotografia 19"
    },
    ,
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-20.jpg',
            full: 'assets/images/fotogallery/picture-20.jpg',
            alt: 'Fotografia 20'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-21.jpg',
            full: 'assets/images/fotogallery/picture-21.jpg',
            alt: 'Fotografia 21'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-22.jpg',
            full: 'assets/images/fotogallery/picture-22.jpg',
            alt: 'Fotografia 22'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-23.jpg',
            full: 'assets/images/fotogallery/picture-23.jpg',
            alt: 'Fotografia 23'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-24.jpg',
            full: 'assets/images/fotogallery/picture-24.jpg',
            alt: 'Fotografia 24'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-25.jpg',
            full: 'assets/images/fotogallery/picture-25.jpg',
            alt: 'Fotografia 25'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-26.jpg',
            full: 'assets/images/fotogallery/picture-26.jpg',
            alt: 'Fotografia 26'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-27.jpg',
            full: 'assets/images/fotogallery/picture-27.jpg',
            alt: 'Fotografia 27'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-28.jpg',
            full: 'assets/images/fotogallery/picture-28.jpg',
            alt: 'Fotografia 28'
        },
        {
            type: 'image',
            thumb: 'assets/images/fotogallery/thumbs/picture-29.jpg',
            full: 'assets/images/fotogallery/picture-29.jpg',
            alt: 'Fotografia 29'
        }
];

export default fotogalleryItems;
